import fp from 'lodash/fp';
import { paginationSuccessHandler } from '../reducerPaginationHandler';

export const createFetchOneHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    fp.set(`all.${response.id}`, response, state),
  [routine.FAILURE]: (state, { error }) =>
    fp.set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export const createFetchManyHandler = (routine, keyProp = 'id') => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    all: {
      ...state.all,
      ...fp.keyBy(keyProp, fp.getOr([], 'items', response))
    },
    ...(fp.has('pagination', state)
      ? {
          pagination: paginationSuccessHandler(
            state.pagination,
            response,
            keyProp
          )
        }
      : {})
  }),
  [routine.FAILURE]: (state, { error }) =>
    fp.set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export const createSaveHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    saving: true,
    saved: false,
    savingError: null
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    saved: true,
    all: fp.set(response.id, response, state.all)
  }),
  [routine.FAILURE]: (state, { payload: error }) =>
    fp.set('savingError', error, state),
  [routine.FULFILL]: fp.set('saving', false)
});

export const createUpdateHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    saving: true,
    saved: false,
    savingError: null
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    saved: true,
    all: fp.set(response.id, response, state.all)
  }),
  [routine.FAILURE]: (state, { payload: error }) =>
    fp.set('savingError', error, state),
  [routine.FULFILL]: fp.set('saving', false)
});

export const createDeleteHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, deleting: true, deleted: false }),
  [routine.SUCCESS]: (state, { payload: { id } }) => ({
    ...state,
    deleted: true,
    all: fp.isArray(state.all)
      ? fp.reject({ id }, state.all)
      : fp.omit(id, state.all)
  }),
  [routine.FAILURE]: (state, { payload: error }) =>
    fp.set('deletingError', error, state),
  [routine.FULFILL]: fp.set('deleting', false)
});
